import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useUserLocale } from "../../customHooks/useUserLocale";
import { countryWithLandingPage } from "../../utils/constants";
import { useIsMobile } from "../../hooks/responsive";
import { useGlobalState } from "../../GlobalStates";
import { getActiveLuckyDrawCampaign } from "../../services/affiliate";

const CHAT_LINE_URL = "https://line.me/R/ti/p/@sotraveltw";

const SocialFloatingWidgets = () => {
  const { community } = useUserLocale();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [user] = useGlobalState("user");
  const [userLoading] = useGlobalState("userLoading");
  const [hasActiveCampaign, setHasActiveCampaign] = useState(undefined);
  const isLoggedIn = Boolean(user?.id || localStorage.getItem("JWT_TOKEN"));

  useEffect(() => {
    let cancelled = false;
    getActiveLuckyDrawCampaign()
      .then(({ campaign }) => {
        if (!cancelled) setHasActiveCampaign(Boolean(campaign));
      })
      .catch(() => {
        if (!cancelled) setHasActiveCampaign(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Logged-out visitors see the welcome gift in this position instead.
  if (
    window.isInApp ||
    community !== "tw" ||
    userLoading ||
    !isLoggedIn ||
    hasActiveCampaign !== false
  ) {
    return null;
  }

  // Check if current path should show widgets
  const shouldShowWidgets = () => {
    const pathname = location.pathname.toLowerCase();

    // Aurora campaign ships its own dedicated floating CTA (envelope),
    // so we hide the global widgets here to avoid CTA collision.
    if (pathname === "/c/aurora") return false;

    if (pathname === "/") return true;
    if (pathname.startsWith("/all-trips")) return true;
    if (pathname.startsWith("/trip/")) return true;
    if (pathname.startsWith("/trips/")) return true;

    // Landing pages: /mongolia, /japow, /weekend, etc.
    return countryWithLandingPage.some(
      (page) => pathname === `/${page}` || pathname.startsWith(`/${page}/`)
    );
  };

  if (!shouldShowWidgets()) return null;

  return (
    <div
      className={`tw-fixed tw-bottom-24 tw-z-[999] tw-flex tw-flex-col tw-gap-3 ${isMobile ? "tw-right-4" : "tw-right-8"}`}
    >
      {/* Line */}
      <a
        href={CHAT_LINE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#22ba52] tw-shadow-lg tw-transition-transform hover:tw-scale-110"
        aria-label="Join our Line group"
      >
        <img src="/icons/line.webp" alt="Line" className="tw-h-7 tw-w-7" />
      </a>
    </div>
  );
};

export default SocialFloatingWidgets;
